import { SummaryFeatureList } from '../types';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const EnterpriseFeatureList: SummaryFeatureList = [
  'private_apps',
  'flexible_plan_types',
  'hipaa_enabled',
  'analyze_can_share_customize_branding',
  'integrations',
  'admin_dashboard',
  'account_control',
  'enhanced_governance',
  'single_sign_on',
  'team_activity',
  'customer_success',
];

export default EnterpriseFeatureList;
